export default import.meta.ROLLUP_FILE_URL_SAhjGx43G5XMHcf$9w0NuA